import { ApiMessageType } from '../api_message_types'
export default class DialogQuestion {
  constructor(message, messageChannel) {
    this.text = message.text
    this.answers = message.answers
    this.messageChannel = messageChannel
  }
  setAnswer(text) {
    let response = text
    if (typeof text === 'number') {
      if (text < this.answers.length) {
        response = this.answers[text]
      }
    }
    this.messageChannel.send({
      type: ApiMessageType.QUESTION_ANSWER,
      text: response,
    })
  }
}
